import React, {useCallback} from 'react';
import clsx from 'clsx';
import ReactTooltip from 'react-tooltip';
import {useGeneratedThumbnail} from "presentation/common/components/style-guide/pdf-viewer/hooks";
import {ThumbnailLoadingIndicator} from './thumbnail-loading-indicator';
import {DownloadIcon} from './download';
import {PreviewIcon} from './preview';
import {downloadFile} from "presentation/common";

import styles from './thumbnail-item.module.scss';

export const ThumbnailItem = ({element, onSelected, isSelected}) => {
  const {value, loading, error} = useGeneratedThumbnail(element);

  const hideToolTip = () => {
    setTimeout(() => {
      ReactTooltip.hide();
    }, 0);
  };
  const open = useCallback(() => {
    hideToolTip();
    window.open(element.url, '_blank');
  }, [element.url]);

  const download = useCallback(() => {
    hideToolTip();
    downloadFile(element.downloadUrl, element.fileName);
  }, [element.downloadUrl, element.fileName]);

  if (loading) return <ThumbnailLoadingIndicator/>;

  return (
    <>
      <ReactTooltip
        id="openTooltip"
        type="info"
        effect="solid"
        textColor="var(--primary)"
        border
        borderColor="var(--primary)"
        backgroundColor="white">
        Abrir
      </ReactTooltip>

      <ReactTooltip
        id="downloadItemTooltip"
        type="info"
        effect="solid"
        textColor="var(--primary)"
        border
        borderColor="var(--primary)"
        backgroundColor="white">
        Descargar
      </ReactTooltip>

      <div className={clsx(styles.container, {[styles.isSelected]: isSelected})} tabIndex={1}  onClick={() => onSelected?.(element)}>
        <div className={styles.image}>
          {
            error
              ? <span style={{fontSize: '13px'}} className="text-red-600 text-center pb-10">
                  Error cargando el documento.
                </span>
              : <img src={value} alt="thumbnail-item"/>
          }
        </div>
        <div className={styles.info}>
          <h3>{element.name}</h3>
          <p>Adjuntado: {element.createAt}</p>
          <div className="flex w-full gap-2 justify-end items-center">
            <PreviewIcon
              className="outline-none cursor-pointer"
              size={16} data-tip data-for="openTooltip"
              onClick={open}/>
            <DownloadIcon
              className="outline-none cursor-pointer"
              data-tip data-for="downloadItemTooltip"
              onClick={download}/>
          </div>
        </div>
      </div>
    </>
  );
};
